module.exports = __webpack_public_path__ + "img/icon-play.fcfd8f91.svg";